import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import ShieldIcon from "@mui/icons-material/VerifiedUser";
import PrintIcon from "@mui/icons-material/Print";

import CertificateDocument from "./Certificados/components/CertificateDocument";
import { renderQrSvg, qrMuestraValue } from "./Certificados/qr";
import { CERTIFICADO_MUESTRA } from "./Certificados/constants";

export default function VerificarCertificado() {
  const [qrSvg, setQrSvg] = useState();

  useEffect(() => {
    let vigente = true;
    renderQrSvg(qrMuestraValue(CERTIFICADO_MUESTRA.folio)).then(
      (svg) => {
        if (vigente) setQrSvg(svg);
      },
      () => {
        if (vigente) setQrSvg(undefined);
      }
    );
    return () => {
      vigente = false;
    };
  }, []);

  const certificado = CERTIFICADO_MUESTRA;

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f3f5f8", py: { xs: 4, md: 6 }, px: 2 }}>
      <Box sx={{ maxWidth: "8.5in", mx: "auto" }}>
        <Box
          className="no-print"
          sx={{
            mb: 3,
            p: 2.5,
            bgcolor: "#fff7ed",
            borderLeft: "4px solid #c2410c",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#c2410c", mb: 1 }}>
            <ShieldIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase" }}>
              Página de muestra
            </Typography>
          </Box>
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#111827", letterSpacing: "-0.02em" }}>
            Así se vería la verificación en línea.
          </Typography>
          <Typography sx={{ mt: 1, fontSize: 14, color: "#374151", lineHeight: 1.6 }}>
            Este folio y este certificado son de demostración. No consultan datos reales
            ni apuntan al dominio interno de la empresa.
          </Typography>
        </Box>

        {!qrSvg ? (
          <Box sx={{ py: 6, display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <CertificateDocument certificado={certificado} qrSvg={qrSvg} />
        )}

        <Button
          className="no-print"
          startIcon={<PrintIcon />}
          onClick={() => window.print()}
          sx={{
            mt: 3,
            height: 46,
            px: 3,
            borderRadius: "12px",
            textTransform: "none",
            fontWeight: 650,
            bgcolor: "#111827",
            color: "#fff",
            "&:hover": { bgcolor: "#1f2937" },
          }}
        >
          Descargar en PDF
        </Button>
      </Box>
    </Box>
  );
}

/*
  Verificación pública por folio (no integrada: el dominio es interno).

  import certificadosService from "../api/certificadosService";
  import { renderQrSvg, verificacionUrl } from "./Certificados/qr";
  import { toCertificado } from "./Certificados/utils";

  const { folio } = useParams();
  const res = await certificadosService.getByFolio(folio);
  const doc = toCertificado(res.data.data);
  const svg = await renderQrSvg(verificacionUrl(folio));
  <Route path="/verificar/:folio" element={<VerificarCertificado />} />
  router.get("/folio/:folio", controller.getByFolio);
*/
